import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  public questions = [
    {
      title: 'Czym jest mSpadek?',
      answer:
        'mSpadek jest serwisem internetowym umożliwiającym szybkie uzyskanie informacji w sprawach związanych ze spadkiem i zachowkiem, w tym wygenerowanie raportu o osobie zmarłej.',
      isOpen: false,
    },
    {
      title: 'Co sprawdza raport?',
      answer:
        'Raport weryfikuje wybrane publiczne i prywatne* rejestry i bazy danych, w których mogła występować\n' +
        'osoba zmarła.',
      isOpen: false,
      asterisk: true,
    },
    {
      title: 'Czego się dowiem z raportu?',
      answer:
        'Otrzymasz informacje w jakich wybranych bazach i rejestrach' +
        ' występuje osoba zmarła. W zależności\n' +
        'od rodzaju raportu dowiesz się jakie to ma konsekwencje prawne i jakie ryzyko albo potencjał się z\n' +
        'tym wiąże.',
      isOpen: false,
    },
    {
      title: 'Co zawiera raport?',
      answer:
        'Raport zawiera wybrane informacje na temat sytuacji osoby zmarłej. W' +
        ' zależności od tego, który\n' +
        'raport wybierzesz informacje te będą albo ogólne albo bardziej szczegółowe, w tym uzupełnione o\n' +
        'komentarze, wyjaśnienia i sugestie. Możesz wybrać Raport Podstawowy albo Raport Rozszerzony.',
      isOpen: false,
    },
    {
      title: 'Jak generowany jest raport i skąd pochodzą dane?',
      answer:
        'Dane pochodzą głównie z urzędowych rejestrów publicznych prowadzonych przez instytucje\n' +
        'państwowe np. Ministerstwo Sprawiedliwości, Ministerstwo Finansów, itp. Dane, które otrzymujesz\n' +
        'odzwierciedlają dane zawarte w wybranych rejestrach i bazach publicznych oraz prywatnych*. Do\n' +
        'raportu dołączone są dokumenty z rejestrów urzędowych np. odpisy z Krajowego Rejestru Sądowego,\n' +
        'Krajowego Rejestru Zadłużonych, itp.',
      isOpen: false,
      asterisk: true,
    },
    {
      title: 'Jaka jest aktualność otrzymanych danych?',
      answer:
        'Informacje pozyskane za pomocą Serwisu są aktualne na godzinę 24:00 dnia poprzedniego.',
      isOpen: false,
    },
    {
      title: 'Co oznacza "pusty" raport?',
      answer:'Zrobiłeś raport, który wykazuje same odpowiedzi negatywne (wynik NIE)? To znaczy, że osoba zmarła nie występuje w żadnej z weryfikowanych baz danych. Jest to również cenna informacja. Oznacza to, że z dużym prawdopodobieństwem można przyjąć, że osoba zmarła:<br><br>' +
        '- nie prowadziła działalności gospodarczej i nie miała długów związanych z taką działalnością,<br>' +
        '- nie była wspólnikiem, ani członkiem zarządu spółki wpisanej do Krajowego Rejestru Sądowego, więc nie ma zobowiązań (długów) wynikających z pełnienia takiej funkcji, <br>' +
        '- nie posiadała udziałów w żadnej spółce wpisanej do Krajowego Rejestru Sądowego, czyli prawdopodobnie nie posiadała aktywów, ani pasywów z tym związanych. Jednak jeżeli posiadała samodzielnie lub łącznie z innymi osobami mniej niż 10% udziałów spółki z ograniczoną odpowiedzialnością lub nie posiadała wszystkich akcji spółki akcyjnej to takie informacje nie są publikowane i nie są widoczne w Dziale 1 KRS,<br>' +
        '- nie otrzymała pomocy państwowej, którą należałoby spłacić i która mogłaby być zobowiązaniem (długiem), <br>' +
        '- nie posiadała niespłaconych mandatów w stosunku do Skarbu Państwa,<br>' +
        '- nie znajdowała się w Krajowym Rejestrze Zadłużonych co samo w sobie jest bardzo dobrą informacją. <br><br>' +
        'Mimo tego, że raport jest "pusty" otrzymujesz wiele istotnych informacji. Pamiętaj, że wpisy w bazach i rejestrach, nawet tych urzędowych, są wykonywane z pewnym opóźnieniem. Jeśli przypuszczasz, że osoba zmarła powinna występować w weryfikowanej bazie danych rozważ ponowne wykonanie raportu za jakiś czas, np. za miesiąc lub za 3 miesiące.',
      isOpen: false,
    },
    {
      title: 'Który raport mam wybrać?',
      answer:
        'Jeśli zastanawiasz się, który raport wybrać możesz zacząć od Raportu Podstawowego. Jeżeli okaże się, że osoba zmarła występuje choć w jednej bazie danych (wynik TAK) wtedy zrób Raport Rozszerzony, aby dowiedzieć się więcej i otrzymać oficjalne dokumenty. Do Raportu Rozszerzonego dołączone są dokumenty z rejestrów np. odpisy z Krajowego Rejestru Sądowego, Krajowego Rejestru Zadłużonych, itp. Jeżeli Raport Podstawowy wyjdzie „pusty” otrzymasz cenne informacje i oszczędzisz pieniądze. Sprawdź FAQ - Co oznacza „pusty” raport?',
      isOpen: false,
    },
    {
      title: 'Po co płacić za Raport Rozszerzony skoro jest Raport Podstawowy za 9 zł?',
      answer:
        'Raport Rozszerzony zawiera więcej informacji. Wyjaśnia również ryzyka związane z występowaniem osoby zmarłej w danej bazie. Dodatkowo otrzymujesz w nim załączniki w postaci odpisów z urzędowych rejestrów publicznych, np. Krajowego Rejestru Sądowego, Krajowego Rejestru Zadłużonych, itp.',
      isOpen: false,
    },
    {
      title: 'Co oznacza "Pominięty" w raporcie?',
      answer:
        'Jeżeli nie podałeś numeru NIP osoby zmarłej to nie można sprawdzić niektórych baz danych. W takim przypadku w danej rubryce widoczne jest słowo „pominięty”. Oznacza ono, że dana baza nie została sprawdzona.',
      isOpen: false,
    },
    {
      title: 'Czym się różni mSpadek od informacji uzyskanej od AI?',
      answer:
        'Nikt nie odpowiada za działanie AI, które często udziela błędnych lub niepełnych informacji. Nigdy nie ma' +
        ' pewności jakie wyniki otrzymasz. AI nie ma bezpośredniego dostępu do wszystkich baz i rejestrów' +
        ' państwowych, ani gwarancji aktualności danych. Dlatego pamiętaj, że odpowiedzi AI mogą być błędne choć' +
        ' sprawiają wrażenie prawidłowych. mSpadek tworzy raport na podstawie rzeczywistych danych pobieranych z' +
        ' rejestrów publicznych i komercyjnych. Nasz system integruje się z wybranymi rejestrami poprzez oficjalne' +
        ' interfejsy API. Dlatego informacje, które otrzymujesz pochodzą bezpośrednio ze źródłowych baz danych, w' +
        ' tym publicznych. Oznacza to, że Twój raport odzwierciedli stan bazy, z którą się łączymy. Ponosimy' +
        ' odpowiedzialność za działanie serwisu mSpadek, natomiast za działanie AI nikt nie odpowiada. Jest to' +
        ' szczególnie ważne w sprawach spadkowych i prawnych, gdzie wiarygodność danych ma istotne znaczenie.',
      isOpen: false,
    },
    {
      title: 'Gdzie znajdę numer PESEL osoby zmarłej?',
      answer:'PESEL osoby zmarłej znajdziesz w jej akcie zgonu. Oprócz tego PESEL znajdziesz w dowodzie osobistym, paszporcie lub w innych dokumentach urzędowych np. akcie urodzenia, dokumentach ubezpieczeniowych np. ZUS, dokumentacji medycznej np. wypisie ze szpitala, SOR, wynikach badań diagnostycznych lub laboratoryjnych, diagnozach lekarskich. Numer PESEL znajdziesz także w innych dokumentach osoby zmarłej np. odpisie z księgi wieczystej, akcie notarialnym, testamencie notarialnym, deklaracjach podatkowych np. PIT, itp.',
      isOpen: false,
    },
    {
      title: 'Gdzie znajdę numer NIP osoby zmarłej?',
      answer:'NIP osoby zmarłej znajdziesz w dokumentach związanych z działalnością gospodarczą, jeśli osoba zmarła ją prowadziła. Sprawdź pisma i wezwania otrzymane z Urzędu Skarbowego lub ZUS, wyciągi bankowe osoby zmarłej, wystawione przez nią faktury VAT, deklaracje podatkowe np. PIT, itp. <br><br>Możesz złożyć oficjalne zapytanie w Urzędzie Skarbowym i sprawdzić, czy osoba zmarła posiadała NIP (więcej informacji zajdziesz <a href="https://www.biznes.gov.pl/pl/portal/ou693" target="_blank" rel="noreferrer">tutaj</a>. Wniosek na formularzu NIP-5/W możesz złożyć osobiście, pocztą lub elektronicznie za pośrednictwem serwisu <a href="https://www.podatki.gov.pl/e-urzad-skarbowy/" target="_blank" rel="noreferrer">e-urząd skarbowy</a>',
      isOpen: false,
    },
  ];

  toggle(item: any): void {
    this.questions.forEach((i) => {
      if (i !== item) {
        i.isOpen = false;
      }
    });
    item.isOpen = !item.isOpen;
  }

  // protected readonly open = open;
}
